import { render, staticRenderFns } from "./ResearcherAvatarOverflow.vue?vue&type=template&id=46986f88&"
import script from "./ResearcherAvatarOverflow.vue?vue&type=script&lang=js&"
export * from "./ResearcherAvatarOverflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
